export const EXIT_CODES = {
  VULNS_FOUND: 1,
  ERROR: 2,
  NO_SUPPORTED_PROJECTS_DETECTED: 3,
  EX_UNAVAILABLE: 69,
  EX_NOPERM: 77,
};
